import React, { useState, useEffect } from 'react';
import dbService from '../../../services/dbService';
import { Spinner } from 'react-bootstrap';
import PageContainer from '../../layout/PageContainer'; // <-- IMPORT

const AuditLog = () => {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchLogs = async () => {
      setIsLoading(true);
      const data = (await dbService.getAll('auditLog')).reverse();
      setLogs(data);
      setIsLoading(false);
    };
    fetchLogs();
  }, []);

  return (
     <PageContainer title="System-Wide Audit Trail">
      <p>A chronological record of all user activities and automated system decisions.</p>
        <div className="card mt-3">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped">
                  <thead>
                  <tr>
                      <th style={{width: '20%'}}>Timestamp</th>
                      <th>User</th>
                      <th>Action</th>
                      <th>Details</th>
                  </tr>
                  </thead>
                  <tbody>
                  {isLoading ? (
                      <tr><td colSpan="4" className="text-center p-5"><Spinner animation="border" /></td></tr>
                  ) : logs.length > 0 ? logs.map(log => (
                      <tr key={log.id}>
                      <td>{new Date(log.timestamp).toLocaleString()}</td>
                      <td>{log.user}</td>
                      <td>{log.action}</td>
                      <td>{log.details}</td>
                      </tr>
                  )) : (
                      <tr>
                          <td colSpan="4" className="text-center text-muted">No audit logs recorded yet.</td>
                      </tr>
                  )}
                  </tbody>
              </table>
            </div>
          </div>
        </div>
     </PageContainer>
  );
};

export default AuditLog;